<div class="card-layout">
  <!-- Header always visible -->
  <div class="d-flex flex-row align-items-center psic-gap-4">
    <img
      src="../../../../assets/images/payment-info/current-statement.svg"
      alt="current-statement"
      class="card-image"
    />
    <div class="card-header">Current Statement</div>
    @if (isLoading()) {
    <app-card-loader></app-card-loader>
    }
  </div>

  @if (!isLoading() && !dcBillingFailed) {
  <div class="d-flex flex-row align-items-center justify-content-between psic-gap-4">
    @if (currentStatementData(); as statement) {
    <div class="d-flex flex-column align-items-start psic-gap-2">
      <h2 class="d-flex flex-row align-items-end psic-gap-1">
        <span>{{ formatAmount(statement.CurrentDueAmount).split('.')[0] }}</span>
        @if (formatAmount(statement.CurrentDueAmount).split('.')[1]; as cents) {
        <p class="alt-bold">{{ '. ' + cents }}</p>
        }
      </h2>
      <span class="caption">Amount to be paid (incl. past due) </span>
    </div>
    @if (statement.PolicyStatus) {
    <lib-tag
      [tagText]="statement.PolicyStatus"
      tagType="lineFill"
      [tagTheme]="policyStatusTheme()"
    ></lib-tag>
    } }
  </div>

  @if (currentStatementData(); as statement) { @if(statement.CurrentDueAmount === 0 &&
  statement.PolicyStatus === 'InForce'){
  <lib-alert
    alertText="You are up to date!"
    [alertTheme]="'success'"
    [alertType]="'small'"
    [inputIcon]="'check-circle'"
  ></lib-alert>
  } @if(statement.PolicyStatus != 'InForce'){
  <lib-alert
    [alertText]="globalMessages.contactCSRMsg"
    [alertTheme]="'default'"
    [alertType]="'small'"
    [inputIcon]="'exclamation-triangle'"
  ></lib-alert>
  }
  <div class="separator"></div>
  <div class="d-flex flex-column psic-gap-5">
    @if (statement.pastDueAmount) {
    <div class="d-flex flex-row justify-content-between align-items-center">
      <div class="caption">Past balance due</div>
      <div class="caption-bold">{{ formatAmount(statement.pastDueAmount) }}</div>
    </div>
    }
    <div class="d-flex flex-row justify-content-between align-items-center">
      <div class="caption">Outstanding balance</div>
      <div class="caption-bold">{{ formatAmount(statement.OutstandingBalance) }}</div>
    </div>
    @if (statement.DueDate) {
    <div class="d-flex flex-row justify-content-between align-items-center">
      <div class="caption">Due date</div>
      <div class="caption-bold">{{ statement.DueDate | date : 'MMM dd, yyyy' }}</div>
    </div>
    } @if(statement.InvoiceNumber){
    <div class="d-flex flex-row justify-content-between align-items-center">
      <div class="caption">Invoice number</div>
      <div class="caption-bold">{{ statement.InvoiceNumber }}</div>
    </div>
    }
    <div class="d-flex flex-row justify-content-between align-items-center">
      <div class="caption">Policy number</div>
      <div class="caption-bold">{{ statement.PolicyReference }}</div>
    </div>
  </div>
  <div class="separator"></div>
  <div
    class="d-flex justify-content-center align-items-center"
    [ngClass]="{ 'flex-column psic-gap-4': isMobile(), 'flex-row psic-gap-6': !isMobile() }"
  >
    <lib-button
      buttonText="Download invoice"
      buttonType="borderless"
      [libIcon]="'download'"
      [disabled]="!statement.InvoiceNumber && !displayBottomSection()"
      (callback)="downloadInvoice(statement.AttachmentId)"
    ></lib-button>
    <lib-button
      buttonText="Make a payment"
      buttonTheme="primary"
      [disabled]="!displayBottomSection()"
      (callback)="navigateToMakePayment()"
    ></lib-button>
  </div>
  } }
</div>
